// extracted by mini-css-extract-plugin
export default {"component":"EmployeeDetailedView_component__ow43N","container":"EmployeeDetailedView_container__FVS-G","key":"EmployeeDetailedView_key__mByNg"};